import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

import { uiBackgroundColor } from "@/view/utils/userContentUIStyles/userContentUIStyles.style";

const { mediaQuery } = mediaQueryStyles;
const { breakpoints } = constants;
const { sm, md } = breakpoints.BreakpointNames;

export const headerMediaCss = (uiType: string): CSSObject => ({
  display: "flex",
  position: "relative",
  marginBottom: "24px",
  width: "100%",

  [mediaQuery.downTo(sm)]: {
    maxWidth: "724px",
  },

  [mediaQuery.downTo(md)]: {
    maxWidth: "905px",
  },

  "&:before, &:after": {
    content: '""',
    backgroundColor: uiBackgroundColor(uiType),
    zIndex: -1,
    height: "50%",
    position: "absolute",
    top: 0,
    width: "100vw",
  },
  "&:before": {
    // Positioning:
    // The background is the full width of the viewport and half the height of the image.
    // Because the height is relative to the image, the left position is relative to the leftmost point of the image.
    // In order to move it to the left edge of the viewport, we need to move it left by half of the viewport width and right by half of the image width.
    left: "calc(-50vw + 50%)",
  },
});
